import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import './styles/site-family.css';
import './appearance/reading.css';
// Preserve links from the original hash-routed site.
if (/^#\/(?:post\/|projects|journal|contact)/.test(window.location.hash)) {
 window.history.replaceState(null, '', window.location.hash.slice(1));
}
ReactDOM.createRoot(document.getElementById('root')).render(<React.StrictMode><BrowserRouter><App /></BrowserRouter></React.StrictMode>);
